/**
 * Athena product configuration.
 *
 * Follows the SystemPrompt / ConversationExporter flag pattern: an unset or
 * "false" VITE_ flag makes the product inert (no access lookup, no switcher
 * button, no route content). The flag is build-time baked per environment.
 */

export const isAthenaEnabled = (): boolean => import.meta.env.VITE_ATHENA_ENABLED === "true";

/**
 * Origin of the Athena Go proxy (its own host; no path mount), e.g.
 * "https://coai-demo-sage-athena-dev.apps.pcf.testservicensw.net" or locally
 * "http://localhost:3000". API calls go to `${athenaApiBase()}/api/...`.
 * Empty means unconfigured: the access lookup then fails, and by design the
 * Athena surface stays closed (the proxy fail-closes its data routes too).
 */
export const athenaApiBase = (): string => (import.meta.env.VITE_ATHENA_API_URL ?? "").replace(/\/+$/, "");
